import {FileResponseBody, Money} from '@dms/api/shared';

export type CreateComplaintApiResponse = /** status 201  */ ComplaintCreatedResponseBody;
export type CreateComplaintApiArg = {
  body: CreateComplaintRequestBody;
};
export type GetComplaintApiResponse = /** status 200  */ ComplaintResponseBody;
export type GetComplaintApiArg = {
  complaintId: string;
};
export type PatchComplaintApiResponse = /** status 200  */ undefined;
export type PatchComplaintApiArg = {
  complaintId: string;
  body: PatchComplaintRequestBody;
};
export type DeleteComplaintApiResponse = /** status 204  */ undefined;
export type DeleteComplaintApiArg = {
  complaintId: string;
};
export type GetSaleVehicleComplaintsApiResponse = /** status 200  */ ComplaintCreatedResponseBody[];
export type GetSaleVehicleComplaintsApiArg = {
  saleVehicleId: string;
};
export type GetVehicleComplaintsApiResponse = /** status 200  */ ComplaintCreatedResponseBody[];
export type GetVehicleComplaintsApiArg = {
  vehicleId: string;
};
export type PatchComplaintResultApiResponse = unknown;
export type PatchComplaintResultApiArg = {
  complaintId: string;
  body: PatchComplaintResultRequestBody;
};
export type ClaimedSolution = 'DISCOUNT' | 'REPAIR' | 'RETURN';
export type ComplaintCreatedResponseBody = {
  id: string;
};
export type CreateComplaintDocumentApiResponse = /** status 200  */ FileResponseBody;
export type CreateComplaintDocumentApiArg = {
  body: ComplaintDocumentRequestBody;
};
export type ComplaintDocumentRequestBody = {
  templateId: string;
  complaintId: string;
};
export type PatchComplaintInspectionApiResponse = unknown;
export type PatchComplaintInspectionApiArg = {
  complaintId: string;
  body: PatchComplaintInspectionRequestBody;
};
export type PatchComplaintInspectionRequestBody = {
  inspectionId: string | null;
};
export type CreateComplaintRequestBody = {
  reason: string;
  receiveAt: string;
  currentMileage: number;
  problem: string | null;
  claimedSolution: ClaimedSolution;
  claimedDiscount: Money | null;
  note: string | null;
  saleVehicleId: string;
};
export type ComplaintResponseBody = {
  id: string;
  code: string;
  reason: string;
  receiveAt: string;
  currentMileage: number;
  problem: string | null;
  claimedSolution: ClaimedSolution;
  claimedDiscount: Money | null;
  note: string | null;
  businessCaseId: string;
  customerId: string;
  saleVehicleId: string;
  vehicleReturned: boolean;
  customerSatisfied: boolean;
  closeAt: string | null;
  resultNote: string | null;
  technicalReport: string | null;
  cost: Money | null;
  returnMileage: number | null;
  createdBy: string;
  createdAt: string;
  documents: ComplaintFileResponseBody[];
  inspectionId: string | null;
};
export type ComplaintFileResponseBody = {
  uploadedAt: string;
} & FileResponseBody;
export type PatchComplaintRequestBody = {
  reason: string;
  receiveAt: string;
  currentMileage: number;
  problem: string | null;
  claimedSolution: ClaimedSolution;
  claimedDiscount: Money | null;
  note: string | null;
};
export type PatchComplaintResultRequestBody = {
  closeAt: string | null;
  resultNote: string | null;
  technicalReport: string | null;
  cost: Money | null;
  returnMileage: number | null;
  vehicleReturned: boolean | null;
  customerSatisfied: boolean | null;
};
